import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { SectionCta } from '../components/SectionCta';
import { KARITO_IMAGE } from '../data/content';
export function AboutKarito() {
  return <section className="w-full bg-white py-14 sm:py-20" aria-labelledby="karito-heading" data-id="element-62" data-mp="3dbqvikn67t8w">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-63" data-mp="3ib2gk5uklkwa">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600" data-id="element-64" data-mp="3iak88aumvg80">
          About the author
        </p>
        <h2 id="karito-heading" className="mx-auto mt-3 max-w-2xl text-center font-display text-[26px] font-black leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-65" data-mp="2pmen3mzo3p7n">
          Dr. Karito
        </h2>

        <div className="mt-9 grid items-center gap-7 md:grid-cols-[0.85fr_1.15fr] md:gap-10" data-id="element-66" data-mp="2zlndy6z8knps">
          <div className="mx-auto w-full max-w-[320px]" data-id="element-67" data-mp="9uqto1jv4etl">
            <img src={KARITO_IMAGE} alt="Dr. Karito, creator of the Aligner Planning Master System, in her dental clinic" className="w-full rounded-2xl object-cover shadow-card" width={800} height={1000} data-id="element-68" data-mp="eun16arrqodw" />
          </div>

          <div data-id="element-69" data-mp="1vq5jafqy5u36">
            <p className="font-display text-[19px] font-extrabold leading-tight text-navy-900 sm:text-[24px]" data-id="element-70" data-mp="1vpmbvsyxao3e">
              A practical clinical library created for professionals who want to plan clear
              aligner cases with a more structured process.
            </p>
            <p className="mt-4 text-[15px] leading-relaxed text-ink-700" data-id="element-71" data-mp="1h1riead3cfp9">
              Dr. Karito built the Aligner Planning Master System™ from the questions she asks
              herself before approving every case — the same questions that separate a plan
              that simply looks good on screen from one that finishes predictably.
            </p>
            <div className="mt-6 rounded-2xl bg-brand-50 p-5" data-id="element-72" data-mp="130yjzejo50gv">
              <QuoteIcon aria-hidden="true" className="h-5 w-5 text-brand-600" data-id="element-73" data-mp="y2dm3lrw2svl" />
              <p className="mt-3 text-[15px] font-semibold leading-relaxed text-navy-900" data-id="element-74" data-mp="oei0hdgu68pw">
                “The goal isn’t to replace your clinical judgment. It’s to give you a framework
                that helps you organize it — so every planning decision starts from clarity,
                not guesswork.”
              </p>
              <p className="mt-3 text-[13px] font-bold uppercase tracking-[0.1em] text-brand-700" data-id="element-75" data-mp="jgpxnoenl26x">
                Dr. Karito
              </p>
            </div>
          </div>
        </div>

        <SectionCta label="Get Dr. Karito’s clinical system" data-id="element-76" data-mp="1c3kembc9hjfn" />
      </div>
    </section>;
}